export const GENERAL_TEXTBOX_TYPE_REQUEST = 'GENERAL_TEXTBOX_TYPE_REQUEST';
export const GENERAL_TEXTBOX_TYPE_SUCCESS = 'GENERAL_TEXTBOX_TYPE_SUCCESS';
export const GENERAL_TEXTBOX_TYPE_FAIL = 'GENERAL_TEXTBOX_TYPE_FAIL';

